import * as JwtService from '@/services/JwtService';

import actions from './_actions';
import getters from './_getters';
import mutations from './_mutators';

const state = {
    user: null,
    isLoggedIn: !!JwtService.getToken,
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./src/infrastructure/auth/store/index.js